<template>
  <div class="statistics">
    <!-- <el-card shadow="always"> -->
      <el-row>
        <el-col :span="20">
          <div id="myCharts" :style="{height: '400px', 'margin-top': '10px'}"></div>
        </el-col>
        <el-col :span="4">
          <el-select v-model="kindVal" placeholder="Please Selected" @change="handleKind">
            <el-option
              v-for="item in kindOpt"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row class="contable" v-if="isShow">
        <el-col>
          <el-card class="box-card tablecard" shadow="never">
            <div slot="header" class="clearfix">
              <span><i class="fa fa-cogs fs14" /> Project Information List ({{subparams}})</span>
            </div>
            <div>
              <el-table
                border
                stripe
                v-loading="loading"
                :data="tableData"
                style="width: 100%"
                :row-key="getRowKeys"
                @sort-change="handleSort"
                :expand-row-keys="expands"
                @expand-change="handleExpand">
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-table
                      border
                      v-loading="subloading"
                      :data="props.row.subtableData"
                      style="width: 100%">
                      <!-- <el-table-column
                        prop=""
                        label=" "
                        width="50">
                      </el-table-column> -->
                      <el-table-column
                        prop="subproject_name"
                        label="Subproject Title"
                        width="210"
                        :show-overflow-tooltip="isOverflow">
                        <template slot-scope="scope">
                          <span class="tablelink" @click="handlesubProurl(scope.row.subproject_id)">
                            {{scope.row.subproject_name}}
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="subproject_id"
                        label="Subproject ID">
                      </el-table-column>
                      <el-table-column
                        prop="px_id"
                        label="PXID">
                      </el-table-column>
                      <el-table-column
                        prop="species"
                        label="Species">
                      </el-table-column>
                      <el-table-column
                        prop="instrument"
                        label="Instrument"
                        :show-overflow-tooltip="isOverflow">
                      </el-table-column>
                      <el-table-column
                        prop="fileCount"
                        label="File Count (size)">
                      </el-table-column>
                      <el-table-column
                        prop="release_date"
                        label="Release Date">
                      </el-table-column>
                    </el-table>
                  </template>
                </el-table-column>
                <el-table-column
                  label="ProjectName"
                  prop="project_name"
                  width="240"
                  :show-overflow-tooltip="isOverflow"
                  sortable>
                  <template slot-scope="scope">
                    <span class="tablelink" @click="handleProurl(scope.row.project_id)">
                      {{scope.row.project_name}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="ProjectID"
                  prop="project_id"
                  width="122"
                  :show-overflow-tooltip="isOverflow"
                  sortable>
                </el-table-column>
                <el-table-column
                  label="Submission Type"
                  prop="submission_type"
                  width="104"
                  :show-overflow-tooltip="isOverflow">
                </el-table-column>
                <el-table-column
                  label="PXID"
                  prop="px_id"
                  width="98"
                  :show-overflow-tooltip="isOverflow"
                  sortable>
                </el-table-column>
                <el-table-column
                  label="Publication"
                  prop="pubmed_id"
                  :show-overflow-tooltip="isOverflow">
                  <template slot-scope="scope">
                    <span>
                      <a :href="publictionUrl+scope.row.pubmed_id">{{scope.row.pubmed_id}}</a>
                      {{scope.row.reference}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Submitter"
                  prop="submitter"
                  width="120"
                  :show-overflow-tooltip="isOverflow"
                  sortable>
                </el-table-column>
                <el-table-column
                  label="Labhead"
                  prop="lab_head"
                  width="120"
                  :show-overflow-tooltip="isOverflow"
                  sortable>
                </el-table-column>
                <el-table-column
                  label="Institution"
                  prop="institution"
                  :show-overflow-tooltip="isOverflow"
                  sortable>
                </el-table-column>
                <el-table-column
                  label="Subproject Count"
                  prop="sub_count"
                  width="100"
                  :show-overflow-tooltip="isOverflow"
                  sortable>
                </el-table-column>
                <el-table-column
                  label="Releasedate"
                  prop="release_date"
                  :show-overflow-tooltip="isOverflow"
                  sortable>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :total="allNum"
                :page-size="pageSize"
                @current-change="handleChangepage"
                class="pagination mb10">
              </el-pagination>
            </div>
          </el-card>
        </el-col>
      </el-row>
    <!-- </el-card> -->
  </div>
</template>

<script>
  import { getTopObjects, getStatProjectList, getStatSubProjectList } from '@/api'
  export default {
    name: 'statistics',
    data() {
      this.commonHeaders = [
        { label: 'Project Title', prop: 'ProjectTitle', sortable: false , align: 'center', fixed: true, width: '170' },
        { label: 'Project ID', prop: 'ProjectID', sortable: false, align: 'center', fixed: false },
        { label: 'Submission Type', prop: 'SubmissionType', sortable: false, align: 'center', fixed: false, width: '110' },
        { label: 'PXID', prop: 'PXID', sortable: false, align: 'center', fixed: false },
        { label: 'Publication', prop: 'Publication', sortable: false, align: 'center', fixed: false },
        { label: 'Submitter', prop: 'Submitter', sortable: false, align: 'center', fixed: false },
        { label: 'Labhead', prop: 'Labhead', sortable: false, align: 'center', fixed: false },
        { label: 'Institution', prop: 'Institution', sortable: false, align: 'center', fixed: false, isOverflow: true },
        { label: 'Subproject Count', prop: 'SubprojectCount', sortable: false, align: 'center', fixed: false, width: '100' },
        { label: 'Release Date', prop: 'Releasedate', sortable: false, align: 'center', fixed: false, isOverflow: true },
      ]
      return {
        activeNames: '1',
        option: {
          title: {
            text: 'Top 10 Species',
            subtext: 'Total datasets:2686',
            left: 'center'
          },
          tooltip: {
            show: true,
            trigger: 'item'
          },
          colorBy: 'data',
          // legend: {
          //   orient: 'vertical',
          //   left: 'left'
          // },
          series: [
          ]
        },
        kindOpt: [{
          value: '1',
          label: 'Species'
        }, {
          value: '4',
          label: 'Disease'
        }, {
          value: '2',
          label: 'Tissue'
        }, {
          value: '3',
          label: 'Cell Type'
        }, {
          value: '9',
          label: 'Instrument'
        }],
        kindVal: '1',
        isOverflow: true,
        tableHeader: [],
        publictionUrl: 'http://www.ncbi.nlm.nih.gov/pubmed?term=',
        pnameUrl: 'https://www.iprox.cn/page/project.html?id=',
        subpnameUrl: 'https://www.iprox.cn/page/subproject.html?id=',
        loading: true,
        subloading: true,
        tableData: [],
        allNum: 0,
        pageSize: 20,
        ajax_data_pie: {
          filters: [{
            item: "objecttype",
            equals: "1"
          }],
          page: {"pageLength": 11, "pageNum": 1}
        },
        kindArr: ['','Species', 'Tissues', 'Cell Types', 'Diseases', '', '', '', '', 'Instruments'],
        isShow: false,
        ajax_data_list: {
          search:{
            object_type: '',
            object_value: ''
          },
          page:{
            startPage: 1,
            pageLength: 20
          },
          order:{
            item: '',
            type: ''
          }
          // filters: [{
          //   item: "objecttype",
          //   equals: "1"
          // }, {
          //   item: "objectvalue",
          //   equals: "Homo sapiens"
          // }],
          // page: {
          //   pageLength: 20,
          //   pageNum: 1
          // }
        },
        ajax_data_sublist: {
          search:{
            project_id: '',
            object_type: '',
            object_value: ''
          },
          page:{
            startPage: 1,
            pageLength: 20
          },
          order:{
            item: '',
            type: ''
          }
        },
        readData: {},
        expands: [],
        getRowKeys (row) {
          return row.project_id
        },
        subkindstr: '',
        subparams: '',
        ajax_data_total: {
          filters: [{
            item: "objecttype",
            equals: "1"
          }, {
            item: "objectclass",
            equals: "total"
          }],
          page: {
            pageLength: 1,
            pageNum: 1
          }
        },
        orderConvert: {
          ascending: 'asc',
          descending: 'desc'
        }
      }
    },
    mounted() {
      this.$route.query.params ? this.kindVal = this.$route.query.params : this.kindVal = '1'
      this.subparams = this.$route.query.subparams
      this.$route.query.params ? this.ajax_data_pie.filters[0].equals = this.$route.query.params : this.ajax_data_pie.filters[0].equals = '1'
      getTopObjects(this.ajax_data_pie).then(res => {
        let resultData = res.result
        let newArr = []
        resultData.map((item, key) => {
          // console.log(key, item)
          let obj = {
            name: item.object_value,
            value: item.object_num
          }
          newArr.push(obj)
        })
        this.ajax_data_total.filters[0].equals = this.kindVal
        getTopObjects(this.ajax_data_total).then(res2 => {
          let totals = res2.result[0].object_num
          let charts = this.$echarts.init(document.getElementById('myCharts'))
          let option = {
            title: {
              text: 'Top 10 ' + this.kindArr[this.kindVal],
              subtext: 'Total datasets: ' + totals,
              left: 'center'
            },
            tooltip: {
              show: true,
              trigger: 'item'
            },
            colorBy: 'data',
            // legend: {
            //   orient: 'vertical',
            //   left: 'left'
            // },
            series: [{
              // name: 'Access From',
              top: '30px',
              type: 'pie',
              radius: ['40%', '70%'],
              label: {
                formatter: "{b}: {c}",
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 22,
                  fontWeight: 'bold',
                  formatter: '{b}: {c}'
                }
              },
              labelLine: {
                show: false
              },
              data: newArr,
              itemStyle: {
                // 通常情况下：
                normal: {
                  // 每个颜色即为colorList数组里的每一项，如果数目多于colorList的长度，则颜色循环使用该数组
                  color: function (colors) {
                    // console.log(typeof (orderArr[params.dataIndex]))
                    // var colorList = ['#ffdd00', '#7f6a9c', '#6aa692', '#fbdad9', '#1280c4', '#d1cbe5', '#96c08e', '#f9a266', '#95d4f5', '#f8bdd7', '#a1a8aa', '#a7dacd', '#fccab3', '#de6c7d']
                    var colorList = ['#1f77b4', '#afc8e8', '#ff7f0e', '#ffbb78', '#2ca02c', '#98df8a', '#d62728', '#ff9896', '#9467bd', '#0c9fb8', '#c5b0d5', '#a7dacd', '#fccab3', '#de6c7d']
                    return colorList[colors.dataIndex]
                  }
                }
              }
            }]
          }
          charts.setOption(option)
          charts.on('click', (params) => {
            this.subparams = params.data.name
            // this.$route.query.params ? this.ajax_data_list.filters[0].equals = this.$route.query.params : this.ajax_data_list.filters[0].equals = this.kindVal
            this.ajax_data_list.search.object_type = this.kindVal
            this.ajax_data_list.search.object_value = params.data.name
            this.ajax_data_list.page.startPage = 1
            getStatProjectList(this.ajax_data_list).then(res => {
              this.isShow = true
              this.loading = false
              this.tableData = res.result
              this.allNum = res.count
            })
          })
        })
        // console.log(newArr)

      })
      if(this.subparams && this.subparams != '') {
        this.ajax_data_list.search.object_type = this.kindVal
        this.ajax_data_list.search.object_value = this.subparams
        this.ajax_data_list.page.startPage = 1
        getStatProjectList(this.ajax_data_list).then(res => {
          this.isShow = true
          this.loading = false
          this.tableData = res.result
          this.allNum = res.count
        })
      }
    },
    created() {
      // this.tableHeader = this.commonHeaders
    },
    methods: {
      handleProurl(param) {
        let routerData = this.$router.resolve({path: '/project', query: {id: param}})
        window.open(routerData.href, '_blank')
      },
      handlesubProurl(param) {
        let routerData = this.$router.resolve({path: '/subproject', query: {id: param}})
        window.open(routerData.href, '_blank')
      },
      handleClick() {},
      handleFilesize(param) {
        let fileSize = param;
        if (fileSize == 0 || fileSize == null) {
          fileSize = ' (' + 0 +'K)';
        } else if (fileSize < 1024) {
          fileSize = ' (' + fileSize.toFixed(2) + 'K)';
        } else if (fileSize >= 1024 && fileSize < 1024 * 1024) {
          fileSize =  ' (' + (fileSize / 1024).toFixed(2)+ 'M)'
        } else {
          fileSize =   ' ('
            + (fileSize / 1024 / 1024).toFixed(2)
            + 'G)'
        }
        return fileSize
      },
      handleChangepage (val) {
        this.loading = true
        this.ajax_data_list.page.startPage = val
        getStatProjectList(this.ajax_data_list).then(res => {
          this.isShow = true
          this.loading = false
          // console.log(res)
          this.tableData = res.result
          this.allNum = res.count
        })
      },
      handleKind() {
        this.isShow = false
        this.ajax_data_pie.filters[0].equals = this.kindVal
        getTopObjects(this.ajax_data_pie).then(res => {
          let resultData = res.result
          let newArr = []
          resultData.map((item, key) => {
            // console.log(key, item)
            let obj = {
              name: item.object_value,
              value: item.object_num
            }
            newArr.push(obj)
          })
          this.ajax_data_total.filters[0].equals = this.kindVal
          getTopObjects(this.ajax_data_total).then(res2 => {
            let totals = res2.result[0].object_num
            let charts = this.$echarts.init(document.getElementById('myCharts'))
            let option = {
              title: {
                text: 'Top 10 ' + this.kindArr[this.kindVal],
                subtext: 'Total datasets: ' + totals,
                left: 'center'
              },
              tooltip: {
                show: true,
                trigger: 'item'
              },
              colorBy: 'data',
              // legend: {
              //   orient: 'vertical',
              //   left: 'left'
              // },
              series: [{
                // name: 'Access From',
                top: '30px',
                type: 'pie',
                radius: ['40%', '70%'],
                label: {
                  formatter: "{b}: {c}",
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: 22,
                    fontWeight: 'bold',
                    formatter: '{b}: {c}'
                  }
                },
                labelLine: {
                  show: false
                },
                data: newArr,
                itemStyle: {
                  // 通常情况下：
                  normal: {
                    // 每个颜色即为colorList数组里的每一项，如果数目多于colorList的长度，则颜色循环使用该数组
                    color: function (colors) {
                      // console.log(typeof (orderArr[params.dataIndex]))
                      // var colorList = ['#ffdd00', '#7f6a9c', '#6aa692', '#fbdad9', '#1280c4', '#d1cbe5', '#96c08e', '#f9a266', '#95d4f5', '#f8bdd7', '#a1a8aa', '#a7dacd', '#fccab3', '#de6c7d']
                      var colorList = ['#1f77b4', '#afc8e8', '#ff7f0e', '#ffbb78', '#2ca02c', '#98df8a', '#d62728', '#ff9896', '#9467bd', '#0c9fb8', '#c5b0d5', '#a7dacd', '#fccab3', '#de6c7d']
                      return colorList[colors.dataIndex]
                    }
                  }
                }
              }]
            }
            // this.option.series = {
            //   // name: 'Access From',
            //   top: '30px',
            //   type: 'pie',
            //   radius: ['40%', '70%'],
            //   label: {
            //     formatter: "{b}: {c}",
            //   },
            //   emphasis: {
            //     label: {
            //       show: true,
            //       fontSize: 22,
            //       fontWeight: 'bold',
            //       formatter: '{b}: {c}'
            //     }
            //   },
            //   labelLine: {
            //     show: false
            //   },
            //   data: newArr,
            //   itemStyle: {
            //     // 通常情况下：
            //     normal: {
            //       // 每个颜色即为colorList数组里的每一项，如果数目多于colorList的长度，则颜色循环使用该数组
            //       color: function (colors) {
            //         // console.log(typeof (orderArr[params.dataIndex]))
            //         // var colorList = ['#ffdd00', '#7f6a9c', '#6aa692', '#fbdad9', '#1280c4', '#d1cbe5', '#96c08e', '#f9a266', '#95d4f5', '#f8bdd7', '#a1a8aa', '#a7dacd', '#fccab3', '#de6c7d']
            //         var colorList = ['#1f77b4', '#afc8e8', '#ff7f0e', '#ffbb78', '#2ca02c', '#98df8a', '#d62728', '#ff9896', '#9467bd', '#0c9fb8', '#c5b0d5', '#a7dacd', '#fccab3', '#de6c7d']
            //         return colorList[colors.dataIndex]
            //       }
            //     }
            //   }
            // }
            charts.setOption(option)
          })
          // console.log(newArr)

        })
      },
      handleExpand(row, expandedRows) {
        this.subloading = true
        console.log(row, expandedRows)
        this.expands = []
        if (expandedRows.length) {
          expandedRows.map((item, key) => {
            this.expands.push(item.project_id)
          })
          this.ajax_data_sublist.search.project_id = row.project_id
          this.ajax_data_sublist.search.object_type = this.kindVal
          this.ajax_data_sublist.search.object_value = this.subparams
          this.ajax_data_sublist.page.startPage = 1
          getStatSubProjectList(this.ajax_data_sublist).then(res => {
            this.subloading = false
            let newData = res.result
            newData.forEach((val, index) => {
              let fileCount = val.file_count;
              let fileSize = this.handleFilesize(val.file_size)
              val.fileCount = fileCount + fileSize
            })
            let subList = newData
            // console.log(subList)
            row.subtableData = subList
          })
        } else {
          this.expands = []
        }
      },
      handleSort (column, prop, order) {
        // console.log(column, prop, order)
        this.loading = true
        this.ajax_data_list.order.item = column.prop
        this.ajax_data_list.order.type = this.orderConvert[column.order]
        if (column.order !== null && column.prop !== null) {
          getStatProjectList(this.ajax_data_list).then(res => {
            this.loading = false
            this.tableData = res.result
            this.allNum = res.count
          })
        } else {
          this.loading = false
        }
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .statistics {
  }
</style>
